var map = {
	"./bloodFat.vue": "./src/views/detect/bloodFat.vue",
	"./bloodGlucose.vue": "./src/views/detect/bloodGlucose.vue",
	"./bloodOxygen.vue": "./src/views/detect/bloodOxygen.vue",
	"./bloodPressure.vue": "./src/views/detect/bloodPressure.vue",
	"./contraction.vue": "./src/views/detect/contraction.vue",
	"./heart.vue": "./src/views/detect/heart.vue",
	"./heartRate.vue": "./src/views/detect/heartRate.vue",
	"./jaundice.vue": "./src/views/detect/jaundice.vue",
	"./move.vue": "./src/views/detect/move.vue",
	"./sleep.vue": "./src/views/detect/sleep.vue",
	"./step.vue": "./src/views/detect/step.vue",
	"./temperature.vue": "./src/views/detect/temperature.vue",
	"./uricAcid.vue": "./src/views/detect/uricAcid.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/detect sync \\.vue$";